var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C5.89543 0 5 0.895428 5 2L4 2V3C4 3.55228 4.44772 4 5 4H9C9.55228 4 10 3.55228 10 3V2H9C9 0.895431 8.10457 0 7 0ZM6 2C6 1.44772 6.44771 1 7 1C7.55229 1 8 1.44772 8 2C8 2.55228 7.55229 3 7 3C6.44771 3 6 2.55228 6 2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H3V3C3 4.10457 3.89543 5 5 5H9C10.1046 5 11 4.10457 11 3V2H14V8H5V18H2C0.89543 18 0 17.1046 0 16L0 2Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9H6V20H16V9ZM8 11H14V13H8V11ZM8 15H14V17H8V15Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/Paste.eb2dd31e5736576f083ad62e5de8de8a.svg";
export { ForwardRef as ReactComponent };